<template>
    <div id="app">
    </div>
</template>

<script>
import formRender from './lib/formRender/Index'
import formConfig from './lib/formConfig/Index'
import datasourceConfig from './lib/datasourceconfig'
import {updateAdornUrl} from "./server/request";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'codemirror/theme/ambiance.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'

const components = {
    formRender,
    formConfig,
    datasourceConfig
}

const install = function(Vue, config={}){
    console.log('custom form std config', config)
    Vue.prototype.$customFormGlobalConfig = {
        ...config,
    }
    Vue.use(ElementUI)
    Object.keys(components).forEach(key =>{
        Vue.component(components[key].name,components[key])
    })
    if(config.adornUrl) {
        updateAdornUrl(config.adornUrl)
    }
}

export default {
    install
};

</script>

<style>

</style>
